import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  plan: null
};

const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    setPlan: (state, action) => {
      state.plan = action.payload;
    },
    updatePlan: (state, action) => {
      const updated = action.payload;
      if (state.plan && state.plan._id === updated._id) {
        state.plan = updated;
      }
    },
    removePlan: (state, action) => {
      const { dashboardId } = action.payload;
      if (state.plan && state.plan._id === dashboardId) {
        state.plan = null;
      }
    },
    resetPlan: () => initialState,
  },
});

export const {
  setPlan,
  updatePlan,
  removePlan,
  resetPlan
} = planSlice.actions;

export default planSlice.reducer;
